import { useState, useEffect, useCallback, useRef } from "react";
import i18n from "@/i18n";

export default function useLanguageTransition(duration = 400) {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [transitionKey, setTransitionKey] = useState(0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleLanguageChanged = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);

    setTransitionKey((k) => k + 1);
    setIsTransitioning(true);

    timerRef.current = setTimeout(() => {
      setIsTransitioning(false);
    }, duration);
  }, [duration]);

  useEffect(() => {
    i18n.on("languageChanged", handleLanguageChanged);
    return () => {
      i18n.off("languageChanged", handleLanguageChanged);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [handleLanguageChanged]);

  return { isTransitioning, transitionKey };
}